import React, {Component} from 'react';
import BsyBtn from "../BsyBtn";
import LoginPasswordLevel from "../LoginPasswordLevel";
import './index.css'
import tipAlert from "../BsyAlertTip/Staticize";
import PubSub from "pubsub-js";
import BsySLoading from "../../components/BsySLoading";

class LoginCodeSetPassword extends Component {
    constructor(props) {
        super(props);
        this.state={
            pwdLevel: window.data_config.pwdLevel,
            showClear:false,
            showPasswordType:false,
            showPassword:false,
            passLevel:false,
            check:true,
            showPasswordCont:false,
            showSkip:false,
            isLoading: false,
            password:''
        }
        this.pubsub_token=PubSub.subscribe("levelPass",(topic,value)=>{
            this.setState({
                passLevel:value.value
            })
        })
        this.pubsub_token1=PubSub.subscribe("codeReg",(topic,value)=>{
            this.setState({
                showSkip:value.value
            })
        })
    }

    passwordValue = (ref) =>{
        this.password = ref
    }

    changePasswordType = () =>{
        this.setState({
            showPasswordType : !this.state.showPasswordType
        })
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub_token);
        PubSub.unsubscribe(this.pubsub_token1);
    }

    changeValue = (event) =>{
        const val = event.target.value
        if(val!==''){
            this.setState({showClear:true,showPassword:true,showPasswordCont:true})
        }else{
            this.setState({showClear:false,showPassword:false})
        }
        this.setState({password:val})
        PubSub.publish('levelValue',{value:val});
    }

    setPassword = () =>{
        const {password, showSkip} = this.state
        if(!this.state.passLevel){
            tipAlert({
                type: "error",
                msg : React.language('set.password.tip')
            })
            return
        }
        this.setState({isLoading: true}, ()=>{
            React.axios('/user/signin',{
                "mode": showSkip ? "regsetpwd":"loginsetpwd",
                "data":{
                    "pwd":password, //姓名
                }
            }).then(res =>{
                if(res.data.code===200){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    window.location.href = res.data.redirectTo
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
                setTimeout(()=>{
                    this.setState({isLoading: false})
                }, 1000)
            }).catch(res=>{
                // tipAlert({
                //     type: "error",
                //     msg : res.response.data.msg
                // })
                setTimeout(()=>{
                    this.setState({isLoading: false})
                }, 1000)
            })
        })

    }

    skipSetPassword = () =>{
        this.setState({isLoading: true},()=>{
            React.axios('/user/signin',{
                "mode":"regsetpwd",
                "data":{
                    "pwd":"", //姓名
                }
            }).then(res =>{
                if(res.data.code===200){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    window.location.href = res.data.redirectTo
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
                setTimeout(()=>{
                    this.setState({isLoading: false})
                }, 1000)
            }).catch(res=>{
                // tipAlert({
                //     type: "error",
                //     msg : res.response.data.msg
                // })
                setTimeout(()=>{
                    this.setState({isLoading: false})
                }, 1000)
            })
        })

    }


    clearInputValue = (event) =>{
        event.target.previousSibling.value="";
        event.target.parentNode.classList.remove('phone')
        this.setState({showClear:false,showPassword:false})
    }
    render() {
        const {showClear, showPasswordType, showPassword,showPasswordCont, showSkip, password, isLoading} = this.state
        return (
            <div className="LoginCodeSetPassword">
                {isLoading && <BsySLoading style={{background: "#fff", zIndex: 9999999999}}/>}
                <div className="codeTitle">
                    <span>{React.language('password.set')}</span>
                </div>
                <div className="setPasswordInput">
                    <input onBlur={()=>{
                        this.setState({
                            showPasswordCont:false
                        })
                    }} onChange={this.changeValue} type={showPasswordType ? "text" : "password"} placeholder={React.language('password.set.warning')}/>
                    {showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close"/>}
                    {showPassword && <i onClick={this.changePasswordType} className={showPasswordType ? "changePasswordType icon-bsy-filter-show" : "changePasswordType icon-bsy-filter-hide"}/>}
                    {showPasswordCont && <LoginPasswordLevel getIsPass={this.passwordValue} password={password} />}
                </div>
                <BsyBtn onClick={this.setPassword} text={React.language('password.set')} />
                {showSkip && <div onClick={this.skipSetPassword} className="passBtn">
                    {React.language('skip')}
                </div>}
            </div>
        );
    }
}

export default LoginCodeSetPassword;